import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { dispatchEvent } from '../utils/dom/element';
import { cardClass } from './styles';
import { Provider } from './context';
import { compose } from '../utils/func';
import resizable from '../hoc/resizable';
import moveable from '../hoc/moveable';
import { modalClass } from '../Modal/styles';
import { isRTL } from '../config';

var Card =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Card, _PureComponent);

  var _super = _createSuper2(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.state = {
      collapsed: props.defaultCollapsed,
      formStatus: ''
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    _this.setFormStatus = _this.setFormStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Card, [{
    key: "getCollapsed",
    value: function getCollapsed() {
      var _this$props = this.props,
          collapsible = _this$props.collapsible,
          collapsed = _this$props.collapsed;
      if (!collapsible) return undefined;
      return collapsed !== undefined ? collapsed : this.state.collapsed;
    }
  }, {
    key: "setFormStatus",
    value: function setFormStatus(status) {
      if (status !== this.state.formStatus) {
        this.setState({
          formStatus: status
        });
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
      var forwardedRef = this.props.forwardedRef;
      if (forwardedRef) forwardedRef(el);
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      var collapsed = !this.getCollapsed();
      if (this.props.onCollapse) this.props.onCollapse(collapsed);else this.setState({
        collapsed: collapsed
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(target) {
      var form = this.element.querySelector('form');
      if (form) dispatchEvent(form, 'submit', target);else console.error(new Error('No form found.'));
    }
  }, {
    key: "render",
    value: function render() {
      var collapsible = this.props.collapsible;
      var collapsed = this.getCollapsed();
      var shadow = this.props.shadow === true ? 'shadow' : this.props.shadow;
      var className = classnames(cardClass('_', shadow, collapsible && 'collapsible', collapsed && 'collapsed', isRTL() && 'rtl'), this.props.className);
      var provierValue = {
        onCollapse: this.handleCollapse,
        collapsible: collapsible,
        collapsed: collapsed,
        formStatus: this.state.formStatus,
        onSubmit: this.handleSubmit,
        setFormStatus: this.setFormStatus
      };
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          ref: this.bindElement,
          style: this.props.style
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: provierValue
        }, this.props.children))
      );
    }
  }]);

  return Card;
}(PureComponent);

Card.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  defaultCollapsed: true,
  collapsible: false
});
export default compose(moveable(".".concat(cardClass('header'), ", .").concat(modalClass('method-title'))), resizable)(Card);